import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.refresh_frame = function () {
  const targetId = this.getAttribute("target");
  if (!targetId) {
    return;
  }

  const frame = document.getElementById(targetId);
  if (!frame) {
    return;
  }

  if (typeof frame.reload === "function" && frame.getAttribute("src")) {
    frame.reload();
    return;
  }

  const refreshUrl = frame.dataset.refreshUrl;
  if (refreshUrl) {
    frame.src = refreshUrl;
  }
};
